var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"px-16 py-6 mx-10 mt-10 text-sm leading-none text-center text-white rounded-full inline-block",class:_vm.color},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }